<template>
  <div class="component-wrapper px-5 pt-5 d-flex flex-column">
    <v-sheet class="assignment-summary align-self-center" rounded>
      <div class="summary-accent"></div>

      <div class="summary-content">
        <div class="summary-main">
          <div class="summary-heading d-flex align-center">
            <div>
              <div
                class="overline font-weight-bold filblue--text summary-client"
              >
                {{ assignment.clientName }}
              </div>
              <h1 class="text-h6 font-weight-medium summary-title">
                {{ assignment.assignmentName }}
              </h1>
            </div>
          </div>

          <div class="summary-dates">
            <div class="summary-date">
              <div>
                <div class="caption text-uppercase grey--text text--darken-1">
                  Start
                </div>
                <div class="body-2 font-weight-medium">
                  {{
                    dayjs
                      .utc(assignment.dateToSend)
                      .local()
                      .format("DD/MM/YYYY")
                  }}
                </div>
              </div>
            </div>

            <div class="summary-date">
              <div>
                <div class="caption text-uppercase grey--text text--darken-1">
                  End
                </div>
                <div class="body-2 font-weight-medium">
                  {{
                    dayjs
                      .utc(assignment.dateToEnd)
                      .local()
                      .format("DD/MM/YYYY")
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="summary-assignee d-flex flex-wrap align-center">
          <v-icon color="filblue" small class="mr-2">
            mdi-account-outline
          </v-icon>
          <span class="body-2 font-weight-medium mr-2">
            {{ assignment.assigneeFullName }}
          </span>
          <v-chip color="filyellow" x-small>
            {{ assignment.assigneeIdentity }}
          </v-chip>
        </div>
      </div>
    </v-sheet>

    <v-divider class="my-4"></v-divider>

    <div class="text-h6 text-center mb-5">Assignments</div>

    <div class="d-flex flex-column align-self-center">
      <v-menu
        :close-on-content-click="false"
        max-width="290"
        v-for="(questionnaire, index) in assignment.questionnaires"
        :key="questionnaire.questionnaireId"
        offset-x
        right
        ref="languageMenu"
        :disabled="questionnaire.questionnaireTypeId == 'elearn'"
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            class="pa-4 elevation-2 rounded d-flex align-center questionnaire"
            :class="{
              'mb-4': index != assignment.questionnaires.length - 1,
            }"
            v-bind="attrs"
            v-on="on"
            @click="toggleMenu(questionnaire)"
          >
            <div
              class="subtitle-1 font-weight-medium"
              :class="{
                'mr-8':
                  !questionnaire.isFinalized && !questionnaire.dateCompleted,
                'mr-2':
                  questionnaire.isFinalized || questionnaire.dateCompleted,
              }"
            >
              {{ questionnaire.questionnaireName }}
            </div>

            <div
              class="body-2 success--text font-weight-medium mr-8"
              v-if="questionnaire.isFinalized"
            >
              (finalized)
            </div>

            <div
              class="body-2 warning--text font-weight-medium mr-8"
              v-if="!questionnaire.isFinalized && questionnaire.dateCompleted"
            >
              (draft -
              {{
                dayjs
                  .utc(questionnaire.dateCompleted)
                  .local()
                  .format("DD/MM/YY HH:mm")
              }})
            </div>

            <v-icon color="filyellow" class="ml-auto">mdi-arrow-right</v-icon>
          </div>
        </template>

        <div class="white pa-2 d-flex flex-column">
          <v-progress-circular
            size="40"
            width="3"
            indeterminate
            color="filblue"
            v-if="loader"
            class="align-self-center"
          ></v-progress-circular>

          <template v-else>
            <div class="subtitle-1 font-weight-medium mb-4">
              Select Language
            </div>

            <v-list class="pa-0" dense>
              <v-list-item
                v-for="language in languages"
                :key="language.itemKey"
                link
                @click="
                  $router.push(
                    `/assignee/${assignment.userAssignmentId}/questionnaire/${questionnaire.assignUserQuesId}/${language.itemKey}`,
                  )
                "
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ language.itemValue }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-icon>
                  <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </template>
        </div>
      </v-menu>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      menu: null,
      languages: [],
      loader: false,
    };
  },
  computed: {
    ...mapState({
      assignment: (state) => state.assignee.assignment,
    }),
  },
  methods: {
    ...mapMutations(["getAssigneeAssignment"]),
    ...mapActions(["getQuestionnaireLanguages"]),
    async toggleMenu(questionnaire) {
      if (questionnaire.questionnaireTypeId == "elearn") {
        this.$router.push(
          `/assignee/${this.assignment.userAssignmentId}/e-learning/${questionnaire.assignUserQuesId}`,
        );

        return;
      }

      if (this.menu == questionnaire.questionnaireId) return;

      this.menu = questionnaire.questionnaireId;

      this.loader = true;

      try {
        this.languages = await this.getQuestionnaireLanguages(
          questionnaire.questionnaireId,
        );
      } catch (e) {
        console.log(e);
      }

      this.loader = false;
    },
    onSelectQuestionnaire(questionnaire) {
      if (questionnaire.questionnaireTypeId == "elearn") {
        this.$router.push(
          `/assignee/${this.assignment.userAssignmentId}/e-learning/${questionnaire.assignUserQuesId}`,
        );
      } else {
        this.$router.push(
          `/assignee/${this.assignment.userAssignmentId}/questionnaire/${questionnaire.assignUserQuesId}`,
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.assignment-summary {
  width: 100%;
  max-width: 760px;
  overflow: hidden;
  border: 1px solid rgba(26, 52, 91, 0.12);
  box-shadow: 0 8px 24px rgba(26, 52, 91, 0.1) !important;
}

.summary-accent {
  height: 5px;
  background: linear-gradient(
    90deg,
    var(--v-filblue-base),
    var(--v-filyellow-base)
  );
}

.summary-content {
  padding: 20px 24px 16px;
  background: linear-gradient(145deg, #ffffff 45%, #f7f9fc 100%);
}

.summary-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.summary-heading {
  min-width: 0;
}

.summary-client {
  line-height: 1.2;
  letter-spacing: 0.08em !important;
}

.summary-title {
  color: #263238;
  line-height: 1.3;
}

.summary-dates {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}

.summary-date {
  display: flex;
  align-items: center;
  min-width: 130px;
  padding: 3px 16px;
  border-left: 1px solid rgba(26, 52, 91, 0.12);
}

.summary-assignee {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid rgba(26, 52, 91, 0.08);
}

.questionnaire {
  cursor: pointer;
}

@media (max-width: 600px) {
  .component-wrapper {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .summary-content {
    padding: 18px 16px 14px;
  }

  .summary-main {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
  }

  .summary-title {
    font-size: 1.05rem !important;
  }

  .summary-dates {
    width: 100%;
  }

  .summary-date {
    width: 50%;
    min-width: 0;
    padding-left: 10px;
  }

  .summary-date:first-child {
    padding-left: 0;
    border-left: 0;
  }
}
</style>
